import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { AxiosRequestConfig } from "axios";
import { UserBasedVenueSerializer } from "../types/user-venue";

export default class UserBasedVenueRepository extends Repository<UserBasedVenueSerializer> {
  public readonly repositoryName = "UserBasedVenueRepository";

  public readonly endpoint = "api/user/venues";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      currentVenueSession: "session/get/",
      changeVenueSession: "session/{id}/",
    };
  }

  /**
   * Retrieves the venue that the user is currently logged into
   */
  public async currentVenueSession(config?: AxiosRequestConfig) {
    const { data } = await this.request(
      this.buildUrl("currentVenueSession"),
      config
    );

    return data;
  }

  /**
   * Changes the venue that the user is currently logged into
   */
  public async changeVenueSession(
    id: number
  ): Promise<UserBasedVenueSerializer> {
    const { data } = await this.request(
      this.buildUrl("changeVenueSession", {
        id,
      }),
      {
        data: { id },
        method: "PUT",
      }
    );

    return data;
  }
}
